import { render, staticRenderFns } from "./effect.vue?vue&type=template&id=4baa7cae&scoped=true"
import script from "./effect.vue?vue&type=script&lang=js"
export * from "./effect.vue?vue&type=script&lang=js"
import style0 from "./effect.vue?vue&type=style&index=0&id=4baa7cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa7cae",
  null
  
)

export default component.exports